module.exports = __webpack_public_path__ + "img/2024big7.378847bb.png";